import * as R from 'ramda';
// utilities
import * as U from '../../../utilities';
// ui
import {
  Box,
  Flex,
  CancelButton,
  ActionButton,
} from '../../../ui';
//////////////////////////////////////////////////

const commonBtnStyles = {
  ml: 20,
  height: 32,
  width: 120,
  p: '4px 8px',
  fontSize: 14,
  bgColor: 'none',
  background: 'none',
  border: '1px solid',
  borderRadius: '5px',
  textTransform: 'uppercase',
};

const getCancelStyles = ({ theme }) => ({
  ...commonBtnStyles,
  bgColor: theme.colors.grey,
  textColor: theme.colors.black,
});

const getSubmitStyles = ({ theme }) => ({
  ...commonBtnStyles,
  bgColor: theme.colors.lime,
  textColor: theme.colors.black,
});

const getSaveAsNewStyles = ({ theme }) => ({
  height: 32,
  fontSize: 14,
  p: '4px 8px',
  borderRadius: '5px',
  textTransform: 'uppercase',
  bgColor: theme.colors.white,
  textColor: theme.colors.black,
  border: `1px solid ${theme.colors.darkGrey}`,
});

const ButtonsBlock = ({
  theme,
  buttons,
  saveAsNew,
  showSaveAsNew,
  saveAsNewBtnType,
}) => (
  <Box>
    {
      U.isTrue(showSaveAsNew)
      && (
      <ActionButton
        {...getSaveAsNewStyles({ theme })}
        variant='primary'
        onClick={saveAsNew}
        type={R.or(saveAsNewBtnType, 'submit')}
      >
        {U.getTranslation('actions.saveAsNew', 'Save As New')}
      </ActionButton>
      )
    }
    {
      buttons.map((button, i) => (
        <ActionButton
          {...getSubmitStyles({ theme })}
          key={i}
          variant='primary'
          onClick={button.action}
          width={R.or(button.width, 100)}
          type={R.or(button.type, 'submit')}
        >
          {button.btnText}
        </ActionButton>
      ))
    }
  </Box>
);

const SaveCancelBlock = ({
  save,
  theme,
  width,
  formId,
  cancel,
  btnText,
  submitting,
  hideFormSaveBtn,
}) => (
  <Box>
    <CancelButton variant='primary' onClick={cancel} {...getCancelStyles({ theme })}>
      {U.getTranslation('actions.cancel', 'Cancel')}
    </CancelButton>
    {
      R.not(U.isTrue(hideFormSaveBtn))
      && (
      <ActionButton
        {...getSubmitStyles({ theme })}
        type='submit'
        form={formId}
        onClick={save}
        variant='primary'
        width={R.or(width, 150)}
        disabled={U.isTrue(submitting)}
        cursor={U.ifElse(U.isTrue(submitting), 'not-allowed', 'pointer')}
      >
        {R.or(btnText, U.getTranslation('actions.save', 'Save'))}
      </ActionButton>
      )
    }
  </Box>
);

const ReportFormButtons = props => {
  const {
    t,
    pl,
    pr,
    style,
    width,
    theme,
    formId,
    zIndex,
    btnText,
    submitting,
    showSaveAsNew,
    hideFormSaveBtn,
    handleClickSave,
    saveAsNewBtnType,
    handleClickCancel,
    handleClickSaveAsNew,
  } = props;

  return (
    <Flex
      left='0px'
      height={60}
      bottom='0px'
      width='100%'
      style={style}
      position='fixed'
      pl={R.or(pl, 60)}
      pr={R.or(pr, 15)}
      borderTop='1px solid'
      bg={theme.colors.bgColor}
      zIndex={R.or(zIndex, 12)}
      transition='all .2s linear'
      justifyContent='space-between'
      borderColor={theme.colors.middleGrey}
    >
      <ButtonsBlock
        t={t}
        theme={theme}
        showSaveAsNew={showSaveAsNew}
        saveAsNew={handleClickSaveAsNew}
        saveAsNewBtnType={saveAsNewBtnType}
        buttons={R.pathOr([], ['buttons'], props)}
        additionBtns={R.pathOr([], ['additionBtns'], props)}
      />
      <SaveCancelBlock
        t={t}
        theme={theme}
        width={width}
        formId={formId}
        btnText={btnText}
        save={handleClickSave}
        submitting={submitting}
        cancel={handleClickCancel}
        hideFormSaveBtn={hideFormSaveBtn}
      />
    </Flex>
  );
};

export default ReportFormButtons;
